jQuery(document).ready(function ($) {
    $('.para').enllax();

    var sticky = new Sticky('.menubar');

    $(window).scroll(function(){
        $("body:not(.page-template-homepage) .header-content .text").css("opacity", 1 - $(window).scrollTop() / 250);
    });

});

